/* eslint-disable react/prop-types */
import React from 'react'
import { FormControl } from '@mui/material'

const InlineDropdownDiagnosis = ({ obj, handleSelectDiagnosis, setEditIconEnable }) => {
  const inlineText = obj.label.substring(obj.label.indexOf('[') + 1, obj.label.indexOf(']'))
  const optionsObj = obj.subOptions.filter((o) => o.category === inlineText)
  const index = 0
  let value = ''
  let newObj = {} as any
  if (obj.selectedSubOptions) {
    value = ''
    newObj = {
      rootId: obj.rootId,
      label: obj.label.substring(obj.label.indexOf(']') + 1, obj.label.length),
      id: obj.id,
      subOptions: obj.subOptions,
      callout_required: obj.callout_required,
      selectedSubOptions: obj.selectedSubOptions,
      index: index + 1,
    }
  } else {
    newObj = {
      rootId: obj.rootId,
      label: obj.label.substring(obj.label.indexOf(']') + 1, obj.label.length),
      id: obj.id,
      callout_required: obj.callout_required,
      subOptions: obj.subOptions,
    }
    value = 'none'
  }
  const checkValue = (value) => {
    return value.indexOf('[') !== -1
  }
  return (
    <div style={{ display: 'inline' }}>
      {obj.label.substring(0, obj.label.indexOf('['))}
      <FormControl>
        <select
          defaultValue={
            value === ''
              ? obj.selectedSubOptions
                ? obj.index
                  ? obj.selectedSubOptions[obj.index]
                  : obj.selectedSubOptions[0]
                : inlineText
              : 'none'
          }
          onChange={(e) => handleSelectDiagnosis(obj, e)}
        >
          <option value="none" selected disabled hidden>
            {optionsObj[0].category}
          </option>
          {optionsObj.map((optionObj) => {
            return (
              <option value={optionObj.option} className={optionObj.category} id={optionObj.id} key={optionObj.id}>
                {optionObj.option}
              </option>
            )
          })}
        </select>
      </FormControl>
      {!checkValue(newObj.label) && <div style={{ display: 'inline' }}>{newObj.label}</div>}
      {checkValue(newObj.label) && (
        <InlineDropdownDiagnosis
          obj={newObj}
          handleSelectDiagnosis={handleSelectDiagnosis}
          setEditIconEnable={setEditIconEnable}
        />
      )}
    </div>
  )
}

export default InlineDropdownDiagnosis
